// Prevent the script from booting more than once
if (!window.__quickOrderFilterInit) {
  window.__quickOrderFilterInit = true;

  const initBlock = (root) => {
    // Prevent double-init on the same block
    if (root.dataset.filterInit === '1') return;
    root.dataset.filterInit = '1';

    const applyFilter = (
      checkboxSelector,
      groupSelector,
      attrName,
      displayWhenMatch = 'block'
    ) => {
      const boxes = Array.from(root.querySelectorAll(checkboxSelector));
      const groups = Array.from(root.querySelectorAll(groupSelector));
      if (!boxes.length || !groups.length) return;

      const run = () => {
        const selected = new Set();
        for (const cb of boxes) if (cb.checked) selected.add(cb.value);

        for (const el of groups) {
          const key = el.getAttribute(attrName) || '';

          // Items without product type stay visible
          if (!key) {
            el.style.display = displayWhenMatch;
            continue;
          }

          el.style.display = selected.has(key) ? displayWhenMatch : 'none';
        }
      };

      for (const cb of boxes) cb.addEventListener('change', run);
      run();
    };

    applyFilter(
      '.camera-family-filter',
      '.camera-group',
      'data-family',
      'block'
    );
  };

  const initAllBlocks = () => {
    document
      .querySelectorAll('[id^="quick-order-"]')
      .forEach(initBlock);
  };

  // Initial load
  document.addEventListener('DOMContentLoaded', initAllBlocks);

  // Shopify Theme Editor support
  document.addEventListener('shopify:section:load', initAllBlocks);
  document.addEventListener('shopify:section:select', initAllBlocks);
}